import { Component, OnInit, HostListener } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { constants } from "../../../utils/constants";
import { AccountService } from "../../../services/account.service";
import { IAdmin } from "../../../models/account.model";
import { StepperService } from "../../../services/stepper.service";
import { TranslatorService } from '../../../services/translator.service';
import { IErrorAlert } from '../../../interfaces/error.interface';

import helpers from "../../../utils/helpers";

@Component({
  selector: "app-create-admin",
  templateUrl: "./create-admin.component.html",
  styleUrls: ["../../auth.styles.css"],
})
export class CreateAdminComponent implements OnInit {
  constants: any = constants;
  helpers: any = helpers;
  docTypes: any[] = [];
  maxLengthDoc: number;
  loading: boolean = true;
  error: IErrorAlert = null;
  admin: IAdmin;
  form: FormGroup;


  capslock = { ...constants.alerts.capslock, width: 'auto'}
  capslockOn: boolean;

  constructor(
    private _fb: FormBuilder,
    private _router: Router,
    public _account: AccountService,
    public _stepper: StepperService,
    public _translator: TranslatorService
  ) {
    if(!this._account.account.company.ruc) {
      this._router.navigate(['/create-account/company'])
    }
    if (this._account.account.company.id) {
      this.error = constants.alerts.verifyCompany.existingCompany.withoutAdmin;
    }
    this.admin = this._account.getAdminData();
    this._stepper.setCurrent(2);
  }

  ngOnInit(): void {
    this.initForm();
    this._translator.getDocTypes().subscribe(
      (docTypes: any) => {
        this.docTypes = docTypes;
        this.loading = false;
      },
      (err) => {
        this.error = err;
        this.form.controls["docType"].disable();
        this.loading = false;
      }
    );
  }

  initForm() {
    this.form = this._fb.group({
      firstName: [
        this.admin.firstName,
        [
          Validators.required,
          Validators.maxLength(20),
          Validators.pattern(constants.validations.alphabetic.pattern),
        ],
      ],
      lastName: [
        this.admin.lastName,
        [
          Validators.required,
          Validators.maxLength(20),
          Validators.pattern(constants.validations.alphabetic.pattern),
        ],
      ],
      docType: [this.admin.docType, [Validators.required]],
      docNumber: [
        { value: this.admin.docNumber, disabled: true },
        [
          Validators.required,
          Validators.pattern(constants.validations.numeric.pattern),
        ],
      ],
      email: [
        this.admin.email,
        [
          Validators.required,
          Validators.pattern(constants.validations.email.pattern),
        ],
      ],
      charge: [
        this.admin.charge,
        [
          Validators.required,
          Validators.maxLength(60),
          Validators.pattern(constants.validations.alphabetic.pattern),
        ],
      ],
      phone: [this.admin.phone.substring(3), [Validators.required, Validators.minLength(8)]],
      terms: [this.admin.terms, Validators.requiredTrue],
    });

    this.helpers.initFormListeners(this.form);
  }


  onChange(event: any) {
    let control = this.form.controls["docNumber"];
    this.maxLengthDoc = helpers.onChangeDocType(event, control);
  }

  create() {
    this.error = null;
    this.loading = true;
    this.form.value.phone = "519" + this.form.value.phone; 
    this._account.setAdminData(this.form.value);
    this._account.createAccount().subscribe((resp: any) => {
      this._router.navigate(["/create-account/success"]);
    },
    (err: IErrorAlert) => {
      this.error = {...err, width: 'auto'};
      this.loading = false;
    });
  }

  toggleTerms() {
    this.form.get("terms").setValue(!this.form.get("terms").value);
  }

  onClickImputTel(e):void {
    
    if(e.target.selectionStart === 0){
      e.target.setSelectionRange(6,6);
      
    }
       
   
  }

  anyAlert(): boolean {
    return (
      this.capslockOn ||
      this.error !== null
    );
  }
}
